module.exports = __webpack_public_path__ + "static/media/scan_loaded_item_to_confirm.4aaecf6b.svg";